import { render, staticRenderFns } from "./CoachSideNavLayout.vue?vue&type=template&id=57226332&"
import script from "./CoachSideNavLayout.vue?vue&type=script&lang=ts&"
export * from "./CoachSideNavLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports